import { EventType } from "@omni/types/components/tracking/eventType.enum";
import { PageImpressionTrackingInfo } from "@omni/types/components/tracking/tracking-info/impression/pageImpression.trackingInfo";

import { getPageInfo, getUserInfo } from "@/services/tracking/trackers/utils";
import * as TrackingService from "@/services/tracking/tracking.service";
import { TypedAnalyticsEvent } from "@/services/tracking/types/analyticsEvent";

export const track = (): void => {
    const event: TypedAnalyticsEvent<PageImpressionTrackingInfo> = {
        event: EventType.PageImpression,
        payload: {
            eventData: {},
            pageInfo: getPageInfo(),
            userInfo: getUserInfo()
        }
    };

    TrackingService.track(event);
};
